<app-upsell-card
  htmlTitle="Complete your routine with <strong>Azelaic Acid 15%</strong>"
  question="We strongly recommend including Azelaic acid to your routine. Would you like to add it to your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">
    Adding a prescription for azelaic acid helps support clearer skin <em>all day long</em> by addressing redness, dark
    marks, and lingering breakouts that other treatments may miss.
  </p>

  <h3 class="mb-3"><strong>Azelaic Acid 15% = all-day skin support</strong></h3>

  <div class="mb-4">
    <h4 class="mb-2"><strong>AM: calm + protect</strong></h4>
    <p>
      Helps reduce redness and inflammation while controlling acne-causing bacteria throughout the day. Supports an even
      skin tone and helps prevent post-acne dark spots.
    </p>
  </div>

  <div class="mb-4">
    <h4 class="mb-2"><strong>PM: repair + refine</strong></h4>
    <p>Works alongside your main treatment at night to improve texture, fade discoloration, and keep pores clear.</p>
  </div>

  <h3 class="mb-3"><strong>Why add it?</strong></h3>
  <ul class="mb-4">
    <li>Targets acne, redness, and dark spots in one step</li>
    <li>Safe for sensitive and acne-prone skin</li>
    <li>Complements both topical and oral acne treatments</li>
    <li>Helps maintain results long-term</li>
  </ul>
</app-upsell-card>
